import { convertFieldRefToFieldId } from './field';
import { SchedulerJobStatus } from './scheduler';
export function isErrorDetails(results) {
    return results.error !== undefined;
}
export const isApiSqlRunnerJobSuccessResponse = (response) => response.status === SchedulerJobStatus.COMPLETED;
export const isApiSqlRunnerJobErrorResponse = (response) => response.status === SchedulerJobStatus.ERROR;
export const isApiSqlRunnerJobPivotQuerySuccessResponse = (response) => response.status === SchedulerJobStatus.COMPLETED;
export const prefixPivotConfigurationReferences = (config, prefix) => {
    if (!config || !config.indexColumn) {
        return undefined;
    }
    return {
        ...config,
        indexColumn: {
            ...config.indexColumn,
            reference: convertFieldRefToFieldId(config.indexColumn.reference, prefix),
        },
        valuesColumns: config.valuesColumns.map((col) => ({
            ...col,
            reference: convertFieldRefToFieldId(col.reference, prefix),
        })),
        groupByColumns: config.groupByColumns?.map((col) => ({
            ...col,
            reference: convertFieldRefToFieldId(col.reference, prefix),
        })),
        sortBy: config.sortBy?.map((sort) => ({
            ...sort,
            reference: convertFieldRefToFieldId(sort.reference, prefix),
        })),
    };
};
//# sourceMappingURL=sqlRunner.js.map